import { useState } from 'react';

/** Zoom state that is controlled when `scaleProp` + `onScaleChange` are supplied, local otherwise. */
export const usePreviewScale = (
  scaleProp?: number,
  onScaleChange?: (scale: number) => void
) => {
  const [internalScale, setInternalScale] = useState(1.0);

  const scale = scaleProp ?? internalScale;
  const setScale = (next: number) =>
    onScaleChange ? onScaleChange(next) : setInternalScale(next);

  return { scale, setScale };
};
